import { Box, Grid, Table, TableCell, TableRow } from '@mui/material';
import React from 'react';
import { getTipoSangre } from '../../../../widgets/fields/TiposSangreField';
import CodeQrComponent from '../../../usuario/usu_entidades/components/code_qr';

const DetalleExpandeEstudiantes = ({ data, qrRef }) => {
  return (
    data && (
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={2} sx={{ p: 1 }}>
          {/* <Grid item xs={12} md={12}>
            <CodeQrComponent type="bar" value={data.usuario.perfil.dni} />
          </Grid> */}
          <Grid item xs={12} md={3}>
            <Grid container spacing={2} sx={{ p: 1 }}>
              <Grid item xs={12} md={12}>
                <CodeQrComponent
                  qrRef={qrRef}
                  size={100}
                  maxWidth={100}
                  value={data.usuario.codeqr}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={9}>
            <Table width="100%">
              <TableRow>
                <TableCell>
                  <strong>Fecha de nacimiento:</strong>
                  <br />
                  {data.usuario.perfil.fechaNacimiento ?? '--'}
                </TableCell>
                <TableCell>
                  <strong>Tipo de sangre:</strong>
                  <br />
                  {data.usuario.perfil.tipoSangre
                    ? getTipoSangre(data.usuario.perfil.tipoSangre)
                    : '--'}
                </TableCell>
                <TableCell>
                  <strong>Tiene internet:</strong>
                  <br />
                  {data.usuario.perfil.internet ? 'Si' : 'No'}
                </TableCell>
              </TableRow>
            </Table>
          </Grid>
        </Grid>
      </Box>
    )
  );
};

export default DetalleExpandeEstudiantes;
